<p-drawer
  [visible]="visible()"
  position="right"
  styleClass="!w-[50vw] max-md:!w-full"
  [showCloseIcon]="false"
  data-testid="document-preview-drawer"
  (onHide)="onClose()"
>
  <!-- Header -->
  <ng-template pTemplate="header">
    <div class="flex w-full items-center justify-between gap-4">
      <span class="truncate text-sm font-semibold text-slate-800">
        {{ document()?.storageFile?.originalName ?? 'Document' }}
      </span>
      <p-button
        icon="pi pi-times"
        severity="secondary"
        [text]="true"
        data-testid="document-preview-close-button"
        (onClick)="onClose()"
      />
    </div>
  </ng-template>

  <!-- Body: split layout -->
  <div class="flex h-full min-h-0 gap-0">
    <!-- Left pane — preview (60%) -->
    <div
      class="flex w-[60%] shrink-0 flex-col bg-slate-50 border-r border-slate-200 overflow-hidden"
    >
      @if (isLoadingUrl()) {
        <div class="flex flex-1 items-center justify-center" data-testid="document-preview-loading">
          <p-skeleton width="100%" height="100%" />
        </div>
      } @else if (!viewUrl()) {
        <div
          class="flex flex-1 flex-col items-center justify-center gap-3 p-6 text-center"
          data-testid="document-preview-unavailable"
        >
          <i class="pi pi-file text-4xl text-slate-300"></i>
          <p class="m-0 text-sm text-slate-500">
            {{ 'common.documents.preview.unavailable' | translate }}
          </p>
          <p class="m-0 text-xs text-slate-400">
            {{ 'common.documents.preview.downloadToView' | translate }}
          </p>
        </div>
      } @else if (isPdf()) {
        <iframe
          [src]="safeUrl"
          class="flex-1 w-full border-0"
          title="Document preview"
          data-testid="document-preview-iframe"
        ></iframe>
      } @else if (isImage()) {
        <div class="flex flex-1 items-center justify-center overflow-auto p-4">
          <img
            [src]="viewUrl()"
            class="max-w-full max-h-full object-contain"
            alt="Document"
            data-testid="document-preview-image"
          />
        </div>
      } @else {
        <div
          class="flex flex-1 flex-col items-center justify-center gap-3 p-6 text-center"
          data-testid="document-preview-unsupported"
        >
          <i class="pi pi-file text-4xl text-slate-300"></i>
          <p class="m-0 text-sm text-slate-500">
            {{ 'common.documents.preview.unsupported' | translate }}
          </p>
        </div>
      }
    </div>

    <!-- Right pane — detail + trail (40%) -->
    <div class="flex w-[40%] flex-col overflow-y-auto p-4 gap-4">
      @if (isLoadingDoc()) {
        <p-skeleton height="200px" />
        <p-skeleton height="100px" />
      } @else if (document()) {
        <!-- Detail panel slot (platform-specific) -->
        <ng-content select="[detail-panel]" />

        <hr class="border-slate-100" />

        <!-- Clarifications slot -->
        <ng-content select="[clarifications]" />

        <hr class="border-slate-100" />

        <!-- Audit trail (shared) -->
        <lib-document-audit-trail [events]="document()!.events" />
      }
    </div>
  </div>
</p-drawer>
